module.exports = __webpack_public_path__ + "static/img/img12.058fb79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ychy/img12.png
// module id = AuiR
// module chunks = 1